module.exports = __webpack_public_path__ + "img/add_business.a26d90d7.png";